<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Copy Day Schedule</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="day_schedule.name">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'DayScheduler' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'day_schedule_id_to_copy'
  ],
  computed: {
    ...mapGetters({
      day_schedule: 'singleDaySchedule'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  methods: {
    submit () {
      this.$store.dispatch('copyDaySchedule', {
        dayScheduleIdToCopy: this.day_schedule_id_to_copy,
        daySchedule: this.day_schedule
      })
    }
  }
}
</script>

<style scoped>

</style>
